import { create } from "zustand";

interface MapNoteDetailState {
  openMapNoteId: string | null;
  open: (mapNoteId: string) => void;
  close: () => void;
}

export const useMapNoteDetailStore = create<MapNoteDetailState>((set) => ({
  openMapNoteId: null,
  open: (mapNoteId) => set({ openMapNoteId: mapNoteId }),
  close: () => set({ openMapNoteId: null }),
}));
